export { getToken } from "@fuze/services-auth/dist/token"
